import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";

export default class VerbalReasoningInstruction extends Component {
    constructor(props) {
        super(props);
        this.circleClick = this.circleClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    optionChange(value) {
        this.props.clearDisableNext();
    }

    render() {
        const p = this.props;

        return (
            <div className="test-page-content-inner test-page-instruction test-page-verbal-reasoning-instruction" >
                <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
                <div className="practice-content">
                    {renderPractice(p, this.optionChange)}
                </div>
            </div>
        );
    }
}

function renderPractice(props, optionChange) {
    return (
        <div className="practice-content-inner">
            <div className="question">
                {props.content.question}
            </div>
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOptions(props.content.options, props, optionChange)}
            </div>
        </div>
    );
}

function renderOptions(elems, props, optionChange) {
    return elems.map(function (elem, index) {
        return renderOption(elem, props, index + 1, optionChange);
    });
}

function renderOption(elem, props, optionValue, optionChange) {
    const disabled = props.waitingForSpeech ? 'disabled' : '';
    const id = `option${optionValue}`;

    return (
        <div className="inputGroup" key={optionValue}>
            <input id={id} type="radio" name="option" value={optionValue} onClick={() => optionChange(optionValue)} disabled={disabled} />
            <label htmlFor={id}><span><span /></span></label>
            <span className="option-text">{elem.text}</span>
        </div>
    );
}
